import React, { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";
import {
  Table,
  Spinner,
  Alert,
  Pagination,
  Container,
  Card,
} from "react-bootstrap";

const ROWS_PER_PAGE = 20;

const VIPDataView = ({ currentUser }) => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (!currentUser || !currentUser.userId) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axiosClient.get(`/vip-data/${currentUser.userId}`);

        if (!res.data || !Array.isArray(res.data.data)) {
          setError("Invalid response format.");
          setLoading(false);
          return;
        }

        const data = res.data.data;

        if (data.length === 0) {
          setRows([]);
          setColumns([]);
          setLoading(false);
          return;
        }

        // Extract columns dynamically from first row
        const cols = Object.keys(data[0]);

        setRows(data);
        setColumns(cols);

      } catch (err) {
        console.error("VIPDataView Error:", err);
        setError("Failed to fetch data from API.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentUser]);

  // Pagination Logic
  const totalPages = Math.ceil(rows.length / ROWS_PER_PAGE);
  const paginatedRows = rows.slice(
    (page - 1) * ROWS_PER_PAGE,
    page * ROWS_PER_PAGE
  );

  return (
    <Container className="mt-4">
      <Card className="p-3 shadow-sm">
        <h4 className="mb-3">Store Dispensing Transactions</h4>

        {/* Loading Spinner */}
        {loading && (
          <div className="text-center py-4">
            <Spinner animation="border" />
            <p className="mt-2">Fetching data…</p>
          </div>
        )}

        {/* Error */}
        {!loading && error && <Alert variant="danger">{error}</Alert>}

        {/* No Data */}
        {!loading && !error && rows.length === 0 && (
          <Alert variant="info">No data found.</Alert>
        )}

        {/* Table */}
        {!loading && rows.length > 0 && (
          <>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th key={col}>{col}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {paginatedRows.map((row, i) => (
                  <tr key={i}>
                    {columns.map((col) => (
                      <td key={col}>{row[col]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </Table>

            {/* Pagination */}
            {totalPages > 1 && (
              <Pagination className="justify-content-center">
                {Array.from({ length: totalPages }, (_, idx) => (
                  <Pagination.Item
                    key={idx + 1}
                    active={idx + 1 === page}
                    onClick={() => setPage(idx + 1)}
                  >
                    {idx + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            )}
          </>
        )}
      </Card>
    </Container>
  );
};

export default VIPDataView;
